import { useMutation, useQueryClient } from "react-query";
import { restoreTeacher } from "api/services/teachers";
import { ETeachersQueryKeys } from "api/endpoints/teachers";
import { TTeacher } from "types/api/teacher";
import { TApiError } from "types/api/error";

export const useRestoreTeacher = () => {
  const queryClient = useQueryClient();

  return useMutation<TTeacher, TApiError, number>(
    (teacherId: number) => restoreTeacher(teacherId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(ETeachersQueryKeys.getArchivedTeachers);
        queryClient.invalidateQueries(ETeachersQueryKeys.getTeachers);
      },
    }
  );
};
